
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';

import { getImage, getData } from '../../helpers/indexedDbHelper';
import {useTranslation} from 'react-i18next';
import { useRefresh } from '../../hooks/useRefresh';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import DetailProduct from './DetailProduct';

function Index({dishMenu, setShowDetailProduct, setShowListProduct2}) { 

      const {i18n} = useTranslation();
      const langEng = i18n.language === 'en' ?? false;
  
    const { dish, alldish } = dishMenu;
     
  
    const [dataDish, setDataDish] = useState(dish);
  const [dataDish2, setDataDish2] = useState(false);
      const [dataDesserts, setDataDesserts] = useState(false);
      const [dataDrinks, setDataDrinks] = useState(false);
    
    const [isImageLoading, setIsImageLoading] = useState(true); 
    const [isImageLoadingOne, setIsImageLoadingOne] = useState(true); 
    const [isImageLoadingTwo, setIsImageLoadingTwo] = useState(true); 

    const [image, setImage] = useState(false);
     const [imageOne, setImageOne] = useState(false);
        const [imageTwo, setImageTwo] = useState(false);
    
        const [showListProduct, setShowListProduct] = useState(false);
        const [dishs, setdishs] = useState(false);
  
      const {change} = useRefresh();
        const [menus, setMenus] = useState([]);
    
    const [flavors, setFlavors] = useState(dish.flavors);
    
    const [showSpecials, setShowSpecials] = useState(false);


      const [showDetailProduc2, setShowDetailProduct2] = useState(false);

    
      useEffect(() => {
          getData('menu').then((items) => {
              const data = items.value.data;
              setMenus(data);
          });
      }, [change]);
      
        const [dataCarne, setdataCarne] = useState(false);
      const [carnte, setcarnte] = useState(false);
    
          useEffect(() => {
                menus.map((item) => {
                    
                     if (item.id === 469) {
                        setcarnte(item);
                    }
                });
          }, [menus]);
        
        
         useEffect(() => {
             if (carnte) {
                 carnte.menus.map((item) => {
                     if (item.id === 4375) {
                      setdataCarne(item)
                    
                   }
               })
           }
         }, [carnte]);
    
    
      
    useEffect(() => {
        setIsImageLoading(true);
        setIsImageLoadingOne(true);
        setIsImageLoadingTwo(true);
          fetchImage(`menu-image-h-${dataDish.id}`).then((url) => {
              if (url) {
                  setImage(url);
                  setIsImageLoading(false); 
              }
          });

           fetchImage(`menu-image-one-${dataDish.id}`).then(async (url) => {
               if (url) {
                   const isValid = await isValidImage(url);
                   if (isValid) {
                       setImageOne(url);
                        setIsImageLoadingOne(false);
                    }
                }    
            }); 

        fetchImage(`menu-image-two-${dataDish.id}`).then(async (url) => {
            if (url) {
                const isValid = await isValidImage(url);
                if (isValid) {
                    setImageTwo(url);
                     setIsImageLoadingTwo(false);
                }
                
            }
        });
  
      }, [dataDish]);
      
    
    const isValidImage =(url) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(true); // La imagen se cargó correctamente
                img.onerror = () => resolve(false); // La imagen está rota o no se puede cargar
                img.src = url; // Inicia la carga de la imagen
            });
        }
  
       useEffect(() => {
          menus.map((item) => {
              if (item.id === 490) {
              setDataDesserts(item);
              }
              
              if (item.id === 479) {
                  setDataDrinks(item)
              }
         
          });
      }, [menus]);
  
  
      const fetchImage = async (id) => {
          const imageBlob = await getImage(id);
          if (imageBlob) {
              const imageURL = URL.createObjectURL(imageBlob.data.blob);
              return imageURL;
          }
          return null;
      };
  
  
      const navDish = (position) => {
          const menuIndex = alldish.findIndex(item => item === dataDish);
  
          let newIndex;
          if (position === 1) {
          newIndex = (menuIndex + 1) % alldish.length;
          } else if (position === -1) {
          newIndex = (menuIndex - 1 + alldish.length) % alldish.length;
          } else {
          return;
          }
          const newDish = alldish[newIndex];
          setDataDish(newDish);
      };
    
    useEffect(() => {
        setFlavors(dataDish.flavors)
    }, [dataDish])
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 999}}>
            <LayoutContent showLogo={true} setShowListProduct={setShowDetailProduct} setShowSpecials={() => {
            setdishs(dataDrinks)
            setShowListProduct(true)
        }} goHome={setShowListProduct2}>
                
                <div
                    style={ {
                        position: 'absolute',
                        zIndex: 999,
                        top: '27%',
                        left: 50,
                        }}>
                    <div
                        style={
                        {
                            width: 45,
                            height: 45,
                            backgroundColor: '#000',
                            borderRadius: 100,
                            borderWidth: 3,
                            borderColor: 'white',
                        }
                        }
                        onClick={() => [
                        navDish(-1),
                      
                        ]}>
                        <img
                            style={{width: 30, height: 30, objectFit: 'contain', marginTop: 7}}
                            src={require('./assets/left23.png')}
                        />
                    </div>
                </div>

                 <div
                    style={ {
                        position: 'absolute',
                        zIndex: 999,
                        top: '27%',
                        right: 50,
                        }}>
                    <div
                        style={
                        {
                            width: 45,
                            height: 45,
                            backgroundColor: '#000',
                            borderRadius: 100,
                            borderWidth: 3,
                            borderColor: 'white',
                        }
                        }
                        onClick={() => [
                        navDish(1),
                      
                        ]}>
                        <img
                            style={{width: 30, height: 30, objectFit: 'contain',  marginTop: 7}}
                            src={require('./assets/right2.png')}
                        />
                    </div>
                </div>
                

                        <img
                                    src={require('./assets/topdetail.png')}
                    style={{
                        position: "absolute",
                        top: 20,
                        left: -10,
                                        width: 200,
                                        height: 165,
                                        objectFit: 'contain',
                                        marginBottom: 50,
                        marginTop: 50,
                                        zIndex: 9999
                                    }}
                />
                <img
                                    src={require('./assets/flores.png')}
                    style={{
                        position: "absolute",
                        bottom: 50,
                        right: -10,
                                        width: 200,
                                        height: 165,
                                        objectFit: 'contain',
                                        marginBottom: 50,
                        marginTop: 50,
                                        zIndex: 9999
                                    }}
                />
                <div style={{overflow:'scroll',  opacity: isImageLoading ? 0 : 1, 
                    transition: "opacity 0.5s ease-in-out", paddingInline: 40, background: "#B20B0A", borderRadius: 40, position: "relative"
                }}>
                    
                    <div style={{ padding: '10px 20px', marginTop:20 }}>
                        <div style={{ minHeight: 330}}>
                            <img
                                src={image}
                                alt="Dynamic content"
                                style={{
                                    width: "100%",
                                    height: 360,
                                    objectFit: "cover",
                                    borderRadius: 20,
                                    opacity: isImageLoading ? 0 : 1, 
                                    transition: "opacity 0.5s ease-in-out", 
                                }}
                                onLoad={() => setIsImageLoading(false)} 
                                />
                       </div>

                        <div style={{
                            marginTop: 5,
                            padding: 15,
                          
                            borderRadius: 20,
                            
                        }}>
                                <div style={{
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    display: 'flex',
                                    
                                    
                                }}>

                                    <div style={{
                                        fontFamily: "RoadStore",
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        width: '80%'
                                    }}>
                                        <p className='shor-text-two' style={{fontSize: 32, color: 'white',  textAlign: 'left'}}>
                                        {langEng ? dataDish.name : translate(i18n.language, dataDish.language, dataDish.name)}
                                        </p>
                                    </div>

                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    margin: '0px 10px',
                                    gap: 10,
                                    border: flavors.length === 0 ?'1px solid white': 'none',
                                        width: 120
                                    ,
                                    textAlign: 'center',
                                    alignItems: "center",
                                    borderRadius: 100,
                                        height: 50,
                                    }}>
                                        <p
                                            style={{ fontSize: 24, color: '#fff', fontWeight: 'bold', textAlign: 'center',fontFamily: "LondrinaSolidRegular", }}>
                                            {flavors.length === 0 && (
                                                <>
                                                    {dataDish.price > 0
                                                        ? `$ ${dataDish.label_price ?? ''} ${
                                                            dataDish.price.toFixed(2)
                                                        }`
                                                        : 'Market Price'}
                                                </>
                                            )}
                                        </p>

                                   
                                    </div>
                                </div>
                                
                                <div style={{marginTop: 10}}>
                                    <p
                                       
                                
                                    style={{fontSize: 22, textAlign:'left', color: 'white', fontFamily: "LondrinaSolidLight",}}>
                                    {langEng ? 
                                                    `${dataDish.regular_decription.replace(/\\n/g,'\n')}`
                                                : 
                                                `${translateMenu(
                                                    i18n.language, 
                                                    dataDish.language, 
                                                    dataDish.regular_decription, 
                                                    'regular_decription'
                                                )}`
                                        }
                                        
                                        
                                    </p>
                            </div>
                            

                        {flavors.length > 0 && (
                        <div
                                    style={{
                                display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            flexWrap: 'wrap',
                            marginTop: 5,
                            }}>
                            {flavors.map((item, key) => {
                            return (
                                <div
                                key={key}
                                style={{
                                    backgroundColor: 'white',
                                    width: '29%',
                                    marginHorizontal: 1,
                                    margin: '1px 1px',
                                    borderRadius: 10,
                                    padding: 10,
                                    
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    position: 'relative',
                                    
                                }}>
                                    <p
                                        className='shor-text'
                                        style={{
                                            color: '#B20B0A',
                                            fontSize: 14,
                                            
                                            fontWeight: '900'
                                        }}>
                                            {item.name}
                                    </p>

                                {item.price > 0 ? (
                                    <p
                                    className='shor-text'
                                            style={{
                                         fontWeight: '900',
                                        color: '#B20B0A',
                                      
                                    }}>
                                    $ {item.price}
                                    </p>
                                ) : (
                                    <p
                                    style={{
                                        color: 'white',
                                        fontSize: 9,
                                       
                                    }}>
                                    Market Price
                                    </p>
                                )}
                                </div>
                            );
                            })}
                        </div>
                        )}
                                
                        </div>
                        
                    </div>

                    

                              
                    

                    <div onClick={() => {
                        setShowListProduct(true)
                        setdishs(dataDesserts)
                    }}>
                            <div
                                >
                                <img
                                    src={require('./assets/desserts.png')}
                                    style={{
                                        width: '100%',
                                        height: 165,
                                        objectFit: 'contain',
                                        marginBottom: 20,
                                        
                                    }}
                                />
                                </div>
                        </div>
                </div>


                 
                
            </LayoutContent>
             {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
                goHome={setShowListProduct2}
            />}


             {showDetailProduc2 && <DetailProduct
                                dishMenu={dataDish2}
                                setShowListProduct2={setShowListProduct}
                                setShowDetailProduct={setShowDetailProduct2}
            />}
            


             {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowListProduct2}/>}
        </div>
    );
}
export default Index;